<div class="row ml-1 mt-2">
  <div class="col">
    <small *ngIf="accountCategory== 'DEALER'"><a [routerLink]="['/dealer']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/customers']" class="text-secondary"> Customers</a>
      /<span *ngIf="customer" class="text-secondary"> {{customer.name}}</span></small>
  </div>
</div>

<div *ngIf="customer && customerStatus">
  <div class="row mt-4 bg-light p-1 mr-2 ml-2">
    <div class="col-lg-2 col-md-2 col-sm-4 col-4 text-center align-middle">
      <img *ngIf="customer.image" class="logo-5 rounded-circle" src="{{customer.image}}" alt="{{customer.name}}" />
      <img *ngIf="!customer.image" class="logo-5 rounded-circle" src="assets/images/user_male.png"
        alt="{{customer.name}}" />
      <br>

    </div>
    <div class="col-lg-10 col-md-10 col-sm-8 col-8">
      <div class="font14-700">{{customer.name}}&nbsp;&nbsp;
        <span [ngClass]="{'ACTIVE':'badge-success', 'INACTIVE':'badge-danger', 'INVITED':'badge-warning',
        'DISABLED':'badge-danger'}[customerStatus]"
          class="badge badge-pill txt-small">{{customerStatus | customText}}</span>
      </div>
      <div><span class="font13-600">Email: </span><span class="font13-400">{{customer.username}}</span></div>
      <div><span class="font13-600">Phone: </span><span class="font13-400">{{customer.phone}}</span></div>
      <!-- <div><span class="font13-600">Created On: </span><span
            class="font13-400">{{customer.createdDate | date:'MM/dd/yyyy hh:mm:ss a'}}</span></div>
        <div><span class="font13-600">Last Sign-In: </span><span
            class="font13-400">{{customer.lastSignedIn | date:'MM/dd/yyyy hh:mm:ss a'}}</span></div> -->
    </div>
  </div>
</div>

<div class="row mr-2 ml-2 mt-4 p-1 bg-light">
  <div class="col-12 pl-3 pr-3 pb-2 pt-1 font14-700">Security</div><br>
  <div class="col-12 pl-1">
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="verificationMode" [checked]="true"
        onclick="onTwoStepVerificationCheckboxClick()" enabled>
      <label class="custom-control-label" for="verificationMode"><span class="font13-600">Verification: </span><span
          class="font13-400">2-Step Verification</span></label>
    </div>

  </div>
  <!-- <div class="col-12 pt-2 text-center" *ngIf="customer.id != loggedInUserId">
      <div class="row">
        <div *ngIf="customerStatus == 'ACTIVE'" class="col-12 p-0 text-center">
          <button class="btn btn-light" (click)="onUserDeactivate()">DEACTIVATE</button>
          <button class="btn btn-primary m-2" (click)="onResetPassword()">RESET PASSWORD</button>
        </div>
        <div *ngIf="customerStatus == 'DISABLED'" class="col-12 p-0 text-center">
          <button class="btn btn-primary" (click)="onUserActivate()">ACTIVATE</button>
        </div>
        <div *ngIf="customerStatus == 'INVITED'" class="col-12 p-0 text-center">
          <button class="btn btn-primary" (click)="onInviteResend()">RESEND INVITE</button>
        </div>
      </div>
    </div> -->
</div>

<!-- Drivers -->


<div class="row mr-2 ml-2 mt-4 p-1 bg-light" *ngIf="customer && customer.drivers && customer.drivers.length > 0">
  <div class="col-12 pl-3 pb-2 pt-1">
    <div class="row">
      <div class="col-lg-9 col-md-8 col-sm-6 col-6 mt-2 pr-0 font14-700">
        Drivers
      </div>
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 pl-0 text-right">
              <button [disabled]="isSelfAccount" class="btn btn-primary" (click)="openAddDriver()">Add Driver</button>
          </div> -->
    </div>
    <div class="table-responsive pt-2">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light">
          <tr>
            <th scope="col" width="10%" class="text-center">
              <!-- <button class="btn btn-outline-danger pt-0 pb-0"
                        [disabled]="selectedAdmins.length < 1" data-toggle="modal" data-target="#deleteAdmin"><i
                          class="fa fa-trash"></i></button> -->
            </th>
            <th scope="col" width="12%" class=""></th>
            <th scope="col" width="16%" class="d-none d-sm-table-cell">Name</th>
            <th scope="col" class="d-table-cell d-sm-none">Name</th>
            <th scope="col" width="20%" class="d-none d-sm-table-cell">Email</th>
            <th scope="col" width="15%" class="d-none d-sm-table-cell">Phone</th>
            <th scope="col" width="11%" class="d-none d-sm-table-cell">Relationship</th>
            <th scope="col" width="16%">Vehicles</th>
          </tr>
        </thead>
        <tbody class="max-height-25">
          <tr *ngFor="let driver of customer.drivers; let i = index">
            <th width="10%" scope="row" class="text-center pr-0">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" name="checkbox" class="custom-control-input"
                  [disabled]="driver.id == loggedInUserId" id="driver_{{i}}" (change)="onDriverSelected(driver.id)">
                <label class="custom-control-label" for="driver_{{i}}"></label>
              </div>
            </th>
            <td width="12%" class=" text-center pl-0">
              <!-- <img class="home-grid-image" src="{{driver.avatar}}" alt="{{driver.name}}" /> -->
              <img *ngIf="driver.image" class="home-grid-image" src="{{driver.image}}" alt="{{driver.name}}" />
              <img *ngIf="!driver.image" class="home-grid-image" src="assets/images/user_male.png"
                alt="{{driver.name}}" />
              <!-- <i class="fa fa-window-minimize" style="font-size: 1.1rem; line-height: 0px; color: red;"></i> -->
              <br>
              <!-- <i class="fa fa-window-minimize" style="line-height: 0px; color: green;"></i> -->
              <i *ngIf="driver.status=='ACTIVE'" class="fa fa-window-minimize"
                style="line-height: 0px; color: green;"></i>
              <i *ngIf="driver.status=='INVITED'" class="fa fa-window-minimize"
                style="line-height: 0px; color: rgb(240, 173, 68);"></i>
              <i *ngIf="driver.status=='DISABLED' || driver.status=='INACTIVE'" class="fa fa-window-minimize"
                style="line-height: 0px; color: red"></i>
            </td>

            <td width="16%" class=" d-table-cell d-sm-none">
              <b>{{driver.name}}</b><br>
              <span class="mt-2">{{driver.username}}</span><br>
              <span class="mt-2">{{driver.phone}}</span>
            </td>
            <td class=" d-none d-sm-table-cell">{{driver.name}}</td>
            <td width="20%" class=" d-none d-sm-table-cell">{{driver.username}}</td>
            <td width="15%" class=" d-none d-sm-table-cell">{{customer.phone}}</td>
            <td width="11%">{{driver.relationship | customText }}</td>
            <td width="16%" class="">
              <div *ngFor="let vehicle of driver.vehicles">{{ vehicle.vin}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



<!-- Confirmation Model -->
<div class="modal fade" id="confirmationModel" tabindex="-1" role="dialog" aria-hidden="true">
  <!-- modal-sm -->
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered " role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="confirmationTitle" *ngIf="currentConfirmation.heading != null">
          {{currentConfirmation.heading}}</h5>
        <button id="closeConfirmationModel" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body fix-height-20 d-flex justify-content-center">
        <div class="align-self-center text-center" *ngIf="currentConfirmation.content != null">{{currentConfirmation.content}}</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" (click)="confirm()">OK</button>
      </div>
    </div>
  </div>
</div>
<button type="button" class="btn btn-primary" id="openConfirmationModel" [hidden]="true" data-toggle="modal"
  data-target="#confirmationModel" data-backdrop="static" data-keyboard="false">Hidden Btn</button>